import { render } from "./App.vue?vue&type=template&id=b0939802"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b0939802&lang=css"
script.render = render

export default script